import { z } from 'zod';

export const AdminModalLawSchoolsRankFilterFormSchema = z.object({
  rank: z.string().uuid().nullish(),
});

export type AdminModalLawSchoolsRankFilterFormValues = z.infer<
  typeof AdminModalLawSchoolsRankFilterFormSchema
>;
